import React, { Fragment } from 'react'

/**
 * ValidationErrors Properties
 */

const ValidationErrors = ({ errors }) =>
    errors && errors.length ? (
        <span dangerouslySetInnerHTML={{ __html: renderErrors(errors) }} />
    ) : (
        <Fragment>
            <p>
                Please ensure you have accurate account information.{' '}
            </p>
        </Fragment>
    )

export default ValidationErrors

function renderErrors(validationErrors) {
    // Check if any error is related to website configuration
    const hasWebsiteError = validationErrors.some(error => 
        error.includes('website') || 
        error.includes('Website') ||
        error.includes('active website') ||
        error.includes('disabled') ||
        error.includes('associate the carrier')
    )
    
    if (hasWebsiteError) {
        // For website-related errors, just show the error without additional generic text
        return validationErrors.join(' ')
    }
    
    // For other errors, add the generic account information message
    return (
        validationErrors.join(' ') +
        '. Please ensure you have accurate account information.'
    )
}
